import { PencilRuler } from "lucide-react"

export default function StudyStartStep() {
  return (
    <section className="flex flex-col gap-4">
      <header className="flex items-center gap-2">
        <span className="w-fit rounded-lg bg-primary-50 p-1.5">
          <PencilRuler className="size-4 text-primary-500" />
        </span>
        <h1 className="text-base font-bold">Estudio: Tus actividades</h1>
      </header>
      <p className="text-left text-sm text-muted-foreground">
        En la vista semanal y diaria de la sección Estudio vas a encontrar todas las actividades que
        tenés asignadas en tu planificación. Organizalas, hacelas a tu ritmo y avanzá en cada
        materia.
      </p>
    </section>
  )
}
